/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Hero_Stat_AiInputs */

const en_directory_home_hero_stat_ai = /** @type {(inputs: Directory_Home_Hero_Stat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`views by AI Agents`)
};

const zh_directory_home_hero_stat_ai = /** @type {(inputs: Directory_Home_Hero_Stat_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次 AI Agent 浏览`)
};

/**
* | output |
* | --- |
* | "views by AI Agents" |
*
* @param {Directory_Home_Hero_Stat_AiInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_hero_stat_ai = /** @type {((inputs?: Directory_Home_Hero_Stat_AiInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Hero_Stat_AiInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_hero_stat_ai(inputs)
	return zh_directory_home_hero_stat_ai(inputs)
});
export { directory_home_hero_stat_ai as "directory.home.hero.stat_ai" }